module.exports = __webpack_public_path__ + "static/media/Arabic.ebde8510.gif";